import * as React from 'react';
import {FunctionComponent} from 'react';
import {IndoorPartialWorkout} from '../../../../Models/PartialWorkout';
import {ExportButton} from '../Generic/ExportButton';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    indoorPartialWorkout: IndoorPartialWorkout;
    className?: string;
}

export const IndoorWorkoutExport: FunctionComponent<OwnProps> = ({indoorPartialWorkout, className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Export</h5>
            </div>
            <div className="card-body d-flex flex-column">
                <p>Download your workout as CSV, JSON or TCX file.</p>
                <div className="btn-group flex-grow-1">
                    <ExportButton partialWorkout={indoorPartialWorkout} type="json" />
                    <ExportButton partialWorkout={indoorPartialWorkout} type="csv" />
                    <ExportButton partialWorkout={indoorPartialWorkout} type="tcx" />
                </div>
            </div>
        </div>
    );
};
